import { s } from '@search/router/src/schema';
import { SusaninRoute } from '@search/router/src/susanin/SusaninRoute';
import { Tokens } from '@search/router/src/RouterInterfaces';

import {
    developerAppLandingMapper,
    developerLandingMapper
} from '@search/offer-search-routes/src/mappers/newBuilding/mappers';

import type { INewBuildingRouterContext as IRouterContext } from '../types';

export const DeveloperAppLandingType = s.rec({
    developerId: developerLandingMapper.Type,
    developerName: developerLandingMapper.SeoType
});

export type IDeveloperAppLandingType = ReturnType<typeof DeveloperAppLandingType>

export const DeveloperAppLandingSeoType = s.rec({
    origin: s.nullOpt(s.str),
    developerNameSeo: developerAppLandingMapper.SeoType
});

export type IDeveloperAppLandingSeoType = ReturnType<typeof DeveloperAppLandingSeoType>

export const developerAppLandingDefaults = {} as const;

export class DeveloperAppLandingRoute extends SusaninRoute<
    IDeveloperAppLandingSeoType,
    IDeveloperAppLandingType,
    IRouterContext,
    typeof developerAppLandingDefaults
> {
    displayName = 'DeveloperAppLandingRoute';

    protected metadata = DeveloperAppLandingSeoType.config;

    protected pattern(p: Tokens<IDeveloperAppLandingSeoType>) {
        return `${this.patternHost()}/${p.developerNameSeo}/`;
    }

    protected conditions() {
        return {
            ...super.conditions(),
            developerNameSeo: developerAppLandingMapper.keys
        };
    }

    defaults() {
        return developerAppLandingDefaults;
    }

    protected fromQuery() {
        const developerName = 'samolet';

        return DeveloperAppLandingType({
            developerId: developerLandingMapper.typeFromSeo(developerName),
            developerName
        });
    }

    protected toQuery() {
        return DeveloperAppLandingSeoType({
            developerNameSeo: developerAppLandingMapper.seoFromType('samolet')
        });
    }
}
